import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import TextField from '@material-ui/core/TextField';
import { FileUpload } from 'primereact/fileupload';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import { roleMasterActions, userMasterActions } from '../../actions';
import tableRequest from '../../models/tableRequest';
// import { userTypeMasterActions } from '../../actions';
import Switch from '@material-ui/core/Switch';

class DealerMst extends Component {
    constructor(props) {
        super(props);
        this.tblResponse = new tableRequest();
        this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
      
        this.handleChange = this.handleChange.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
        this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this)
        this.resetForm = this.resetForm.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.onHide = this.onHide.bind(this);
        this.getRoleDDL = this.getRoleDDL.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onSort = this.onSort.bind(this);
        this.state = {
            Id: 0,
            IsAdd: true,
            IsEdit: true,
            isActive: true,
            first: 0,
            rows: 5,
            totalRecords:5,
            globalFilter: null,
            sortOrder: '',
            buttonLabel: 'Submit',
            switchAction: false,
            formHeading: 'Add Service Agent ',
          TradeName: '',
    ContactPersonName:'',
    MobileNumber: '',
    District: '',
    PinCode: '',
            IsActive: true,
            CreatedDate: null,
            UpdatedDate: null,
            formError: {
                TradeName: '',
                ContactPersonName: '',
                MobileNumber: '',
                District: '',
                PinCode: ''
            }
        };
    }
    componentDidMount() {
        const userPages = sessionStorage.getItem('assignedPermissionsForUser')
        if (userPages) {
            const assignedPermissions = JSON.parse(userPages);
            const Curenturl = window.location.pathname;
            const nNumber = Curenturl.lastIndexOf('/');
            const pageName = Curenturl.substring(nNumber + 1);

            const obj = assignedPermissions.assigned.filter((x) => {
                return x.ActionName === pageName
            });

            if (obj !== null && obj.length > 0) {
                if (!obj[0].IsEdit) {
                    this.setState({
                        IsEdit: false
                    });
                }
                if (!obj[0].IsAdd) {
                    this.setState({
                        IsAdd: false
                    });
                }
            }
        }

        this.props.fetchApi(this.tblResponse);

        const userId = JSON.parse(sessionStorage.getItem("UserData"));
        this.props.getRoleDDL(userId);
    }

    // componentDidUpdate(prevProps) {
    //     console.log("UserData =>", this.props.UserData);
    //     if (this.props.UserData) {
    //         if (prevProps.UserData !== this.props.UserData) {
    //             // this.props.myProp has a different value
    //             if (this.props.UserData) {
    //                 var e = this.props.UserData;
    //                 this.setState({
    //                     totalRecords: e[0].TotalRows
    //                 });
    //             }
    //         }
    //     } else {
    //         if (this.state.totalRecords !== 0)
    //             this.setState({
    //                 totalRecords: 0,
    //                 first: 0
    //             });
    //     }
    // }
componentDidUpdate(prevProps) {
    if (prevProps.UserData !== this.props.UserData) {

        const data = this.props.UserData;

        if (
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data[0] &&
            data[0].TotalRows !== undefined
        ) {
            this.setState({
                totalRecords: data[0].TotalRows
            });
        } else {
            this.setState({
                totalRecords: 0,
                first: 0
            });
        }
    }
}
    handleChange(event) {
        let { name, value } = event.target;
        let errors = this.state.formError;
        switch (name) {
            case 'IsActive':
                value = event.target.checked;
                break;
            default:
                break;
        }
        this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }

    UpdatedDateTemplate(rowData) {
        if (rowData.UpdatedDate !== null) {
            return (
                <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>
            )
        }
        else {

        }
    }

    CreatedDateTemplate(rowData) {
        if (rowData.UpdatedDate !== null) {

            return (
                <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>
            )
        }
    }


    validateForm(value, name)    {
     
        let errors = this.state.formError;
        let IsValid = true;
        
        switch (name) {
            
            case 'District':
                if (value.length < 1) {
                    IsValid = false;
                    errors.District = "Please enter district.";
                } else errors.District = ''
                break;
            case 'ContactPersonName':
                if (!value) {
                    IsValid = false;
                    errors.ContactPersonName = "Please enter contact person name.";
                } else errors.ContactPersonName = ''
                break;
                  
            case 'MobileNumber':
                if (value.length < 1) {
                    IsValid = false;
                    errors.MobileNumber = "Please enter mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[6-9]\d{9}$/)) {
                        IsValid = true;
                        errors.MobileNumber = "Please enter valid mobile no.";
                    } else errors.MobileNumber = ''
                } else errors.MobileNumber = ''
                break;
            case 'TradeName':
                if (!value) {
                    IsValid = false;
                    errors.TradeName = "Please enter trade name.";
                } else errors.TradeName = ''
                break;
            case 'PinCode':
                if (value.length < 1) {
                    IsValid = false;
                    errors.PinCode = "Please enter pin code.";
                } else errors.PinCode = ''
            default:
                break;
        }

        return IsValid;
    }

    getDropValueOfRole() {
        let roleName = '';
        this.props.UserRoleData.filter(x => {
            if (x.value === this.state.RoleId.toString()) {
                roleName = x.label;
            }
        });

        return roleName;
    }

    getDropValueOfUserType() {
        let usertype = '';
        this.state.UserTypeData.filter(x => {
            if (x.value === this.state.UserTypeId) {
                usertype = x.label;
            }
        });

        return usertype;
    }

    submitForm(event) {
        debugger
        event.preventDefault();
        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
            return isfrmvalid;
        });

        if (isfrmvalid) {
            const formData = {
                Id: this.state.Id,
                District: this.state.District,
                ContactPersonName: this.state.ContactPersonName,
                MobileNumber: this.state.MobileNumber,
                TradeName: this.state.TradeName,
                PinCode: this.state.PinCode,
                TotalRows: this.state.totalRecords             
               
            }
            if (formData.Id > 0) {
                this.props.updateUserDealer(formData);
              setTimeout(() => {
        this.props.fetchApi(this.tblResponse);
    }, 1000)
            }
            else {
                this.props.createUserDealer(formData);
               setTimeout(() => {
        this.props.fetchApi(this.tblResponse);
    }, 1000)
            }

            if (!this.props.showDialog) {
                this.resetForm();
            }
        }
    }

    getRoleDDL(event) {
        this.props.getRoleDDL();
    }
    resetForm() {
        this.setState({
            UserId: '',
            UserTypeId: '',
            District: '',
            ContactPersonName: '',
            MobileNumber: '',
            TradeName: '',
            PinCode: '',
            IsActive: true,
            formError: {
                UserName: '',
                UserTypeId: '',
                Email: '',
                FirstName: '',
                MobileNo: '',
                Password: '',
                ConfirmPassword: '',
            }
        });

        let errors = this.state.formError;
        Object.entries(errors).map(([key]) => {
            errors[key] = '';
            return errors[key];
        });
    }

    //to lazy load
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows, first: event.first });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    onPage(event) {
        this.props.loadingData(true);

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.props.fetchApi(this.tblResponse);
        }, 250);
    }

    //to search
    searchFilter(e) {
        this.props.loadingData(true);
        this.tblResponse.SearchValue = e.target.value;
        this.props.fetchApi(this.tblResponse);
    }

    //to sort
    onSort(event) {
        this.props.loadingData(true);
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.multiSortMeta[0].field === "CreatedDate" ? "CreatedDate" : event.multiSortMeta[0].field;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';//this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.props.fetchApi(this.tblResponse);
    }

    onHide() {
        this.props.onHideShow(false);
        this.resetForm();
    }
    openDialog() {
        this.props.onHideShow(true);
        this.setState({ buttonLabel: 'Submit', formHeading: 'Add Agent' })
    }

    deleteRecord = (rowData) => {
    if (
        window.confirm(
            `Are you sure you want to delete this record?\nTrade Name: ${rowData.TradeName}`
        )
    ) {
        this.props.deleteUserDealer(rowData.Id);

        setTimeout(() => {
            this.props.fetchApi(this.tblResponse);
        }, 1000);
    }
}

    statusBodyTemplate(rowData) {

        if (rowData) {
            return (
                <Checkbox
                    disabled
                    checked={rowData.IsActive}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
            )
        }
    }
    getCurrentDateMMDDYYY() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        return today;
    }
    actionBodyTemplate(rowData) {

        const editMode = (e) => {
            this.props.onHideShow(true);
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update User Agent',
                 Id: rowData.Id || 0,
                TradeName: rowData.TradeName,
                ContactPersonName: rowData.ContactPersonName,
                MobileNumber: rowData.MobileNumber,
                District: rowData.District,
                isActive: rowData.IsActive,
                PinCode: rowData.PinCode
             
            });
        }
    

        if (rowData) {
            return (
                <>
                    {this.state.IsEdit === true ?
                        <div>
                            <Button icon="pi pi-trash" className="p-button-danger mr-2" onClick={() => this.deleteRecord(rowData)}/>
  <Button icon="pi pi-pencil" onClick={editMode} />
                        </div>
                        : ""}
                </>
            )
        }
    }

    render() {
        const renderFooter = (name) => {
            
        }
        const header = (
            <div className="table-header row">
                <div className="col-md-6">
                    <h4>Service Agent Masters</h4>
                </div>
                <div className="col-md-6 text-right">
                    <span className="p-input-icon-left mr-2">
                        <i className="pi pi-search" />
                        <InputText type="search" onInput={(e) => this.searchFilter(e)} placeholder="Global Search" />
                    </span>
                    {this.state.IsAdd === true ?
                        <Button className="mr-2" icon="pi pi-plus" label="Add" onClick={this.openDialog} />
                        : ""}
                </div>
            </div>
        );

        return (
            <div className="datatable-filter-demo">
                <ToastContainer />

                <div className="card">
                    <DataTable value={this.props.UserData}
                        scrollable responsive={true}
                        globalFilter={this.state.globalFilter} header={header}
                        emptyMessage="No data found." sortMode="multiple" paginator={true}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={this.state.rows} style={{ width: '100%' }} rowsPerPageOptions={[5, 10, 20]}
                        totalRecords={this.state.totalRecords}
                        lazy={true} first={this.state.first}
                        onPage={this.onPage} onSort={this.onSort} loading={this.props.loading} ref={(el) => { this.dt = el; }}>
                        <Column field="TradeName" header="Trade Name" sortable></Column>
                        <Column field="ContactPersonName" header="Contact Person Name" sortable></Column>
                        <Column field="MobileNumber" header="Mobile Number" sortable></Column>
                        <Column field="District" header="District" sortable></Column>
                     

                        {this.state.IsEdit === true ?
                            <Column field="Action" header="Action" style={{ width: '120px' }} body={this.actionBodyTemplate}></Column>
                            : <Column field="Action" header="Action" style={{ width: '120px' }} style={{ display: 'none' }}></Column>}
                    </DataTable>
                </div>


<Dialog
    header={this.state.formHeading}
    modal
    dismissableMask={true}
    visible={this.props.showDialog}
    className="popup"
    onHide={this.onHide}
>
    <form onSubmit={this.submitForm} autoComplete="off">
        <div className="row mt-3">

            <div className="col-md-6 pt-2">
                <TextField
                    onChange={this.handleChange}
                    name="TradeName"
                    value={this.state.TradeName}
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Trade Name *"
                />
                {this.state.formError.TradeName &&
                    <div className="error">{this.state.formError.TradeName}</div>}
            </div>

            <div className="col-md-6 pt-2">
                <TextField
                    onChange={this.handleChange}
                    name="ContactPersonName"
                    value={this.state.ContactPersonName}
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Contact Person Name *"
                />
                {this.state.formError.ContactPersonName &&
                    <div className="error">{this.state.formError.ContactPersonName}</div>}
            </div>

            <div className="col-md-6 pt-3">
                <TextField
                    onChange={this.handleChange}
                    name="MobileNumber"
                    value={this.state.MobileNumber}
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Mobile Number *"
                />
                {this.state.formError.MobileNumber &&
                    <div className="error">{this.state.formError.MobileNumber}</div>}
            </div>

            <div className="col-md-12 pt-3">
                <TextField
                    onChange={this.handleChange}
                    name="PinCode"
                    value={this.state.PinCode}
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Pin Code *"
                />
                {this.state.formError.PinCode &&
                    <div className="error">{this.state.formError.PinCode}</div>}
            </div>

            <div className="col-md-12 pt-3">
                <TextField
                    onChange={this.handleChange}
                    name="District"
                    value={this.state.District}
                    size="small"
                    variant="outlined"
                    multiline
                    rows={4}
                    className="fullwidth"
                    label="District *"
                />
                {this.state.formError.District &&
                    <div className="error">{this.state.formError.District}</div>}
            </div>

            <div className="col-md-12 mt-4 text-center">
                <Button
                    label={this.state.IsEdit ? "Update" : "Save"}
                    icon="pi pi-check"
                />
            </div>

            <div className="col-md-12 mt-2">
                Note: Fields marked as (*) are required
            </div>

        </div>
    </form>
</Dialog>



                <Dialog header="Confirmation" visible={this.props.showIsActiveDialog} modal style={{ width: '350px' }}
                    footer={renderFooter('displayConfirmation')} onHide={() => this.props.onHideShowIsActive(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3 confirm-icon" style={{ fontSize: '2rem' }} />
                        <span>Are you sure you want to {this.state.switchAction == true ? "Active" : "InActive"}?</span>
                    </div>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        UserData: state.user.items,
        UserRoleData: state.role.rollddl,
        showDialog: state.role.showDialog,
        loading: state.company.loding,
        showIsActiveDialog: state.user.showIsActiveDialog
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchApi: (obj) => {
            dispatch(userMasterActions.getAllAgent(obj))
        },
        createUserDealer: user => dispatch(userMasterActions.createUserDealer(user)),
        updateUserDealer: user => dispatch(userMasterActions.updateUserDealer(user)),
        inActiveRowDealer: (id, isActive) => dispatch(userMasterActions.inActiveRowDealer(id, isActive)),
        onHideShow: isbool => dispatch(userMasterActions.onHideShow(isbool)),
        onHideShowIsActive: isbool => dispatch(userMasterActions.onHideShowIsActive(isbool)),
        getRoleDDL: (userId) => dispatch(roleMasterActions.getRoleDDL(userId)),
          deleteUserDealer: id => dispatch(userMasterActions.deleteUserDealer(id)),
        loadingData: (isLoding) => dispatch(userMasterActions.loadingData(isLoding))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DealerMst);